/** Delimiter for multi-job field values stored in one column. */
export const JOB_MULTI_SEP = '@multi@'

/** Split multi-job field values by @multi@. */
export function splitJobValues(value) {
  if (value == null) return []
  const s = String(value).trim()
  if (!s) return []
  return s.split(JOB_MULTI_SEP).map((part) => part.trim())
}

function pickPart(parts, index, fallback = '') {
  if (parts.length === 0) return index === 0 ? fallback : ''
  return parts[index] != null ? parts[index] : ''
}

/** Parse a stored job into numbered role entries. */
export function getJobEntries(job) {
  if (!job) return []
  const titles = splitJobValues(job.title)
  const jobTypes = splitJobValues(job.job_type)
  const educationLevels = splitJobValues(job.education_level)
  const experiences = splitJobValues(job.experience)
  const sexes = splitJobValues(job.sex)
  const employees = splitJobValues(job.no_of_employees)
  const sectors = splitJobValues(job.sector)
  const salaries = splitJobValues(job.salary)

  const count = Math.max(
    1,
    titles.length,
    jobTypes.length,
    educationLevels.length,
    experiences.length,
    sexes.length,
    employees.length,
    sectors.length,
    salaries.length,
  )

  const legacy = {
    title: job.title || '',
    job_type: job.job_type || '',
    education_level: job.education_level || '',
    experience: job.experience || '',
    sex: job.sex || '',
    no_of_employees: job.no_of_employees || '',
    sector: job.sector || '',
    salary: job.salary || '',
  }

  return Array.from({ length: count }, (_, i) => ({
    title: pickPart(titles, i, legacy.title),
    job_type: pickPart(jobTypes, i, legacy.job_type),
    education_level: pickPart(educationLevels, i, legacy.education_level),
    experience: pickPart(experiences, i, legacy.experience),
    sex: pickPart(sexes, i, legacy.sex),
    no_of_employees: pickPart(employees, i, legacy.no_of_employees),
    sector: pickPart(sectors, i, legacy.sector),
    salary: pickPart(salaries, i, legacy.salary),
  }))
}

export function formatJobTitles(title) {
  const parts = splitJobValues(title)
  if (!parts.length) return '—'
  return parts.join(' · ')
}

/** True when job_deadline is set and the calendar day after it has started. */
export function isJobExpired(jobOrDeadline) {
  const deadline = typeof jobOrDeadline === 'object' ? jobOrDeadline?.job_deadline : jobOrDeadline
  if (!deadline) return false
  const end = new Date(`${String(deadline).slice(0, 10)}T00:00:00`)
  if (Number.isNaN(end.getTime())) return false
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return today > end
}

/** UI status chip value: expired overrides stored job status when deadline passed. */
export function getJobDisplayStatus(job) {
  if (!job) return ''
  if (isJobExpired(job)) return 'expired'
  return job.status || ''
}

export function formatJobMeta(job) {
  const sectors = splitJobValues(job?.sector).filter(Boolean)
  const salaries = splitJobValues(job?.salary).filter(Boolean)
  const sectorText = sectors.length ? sectors.join(' · ') : '—'
  const salaryText = salaries.length ? salaries.join(' · ') : 'Salary N/A'
  return `${sectorText} · ${salaryText}`
}
